import React, { useCallback } from 'react';
import { Modal, View, Text } from 'react-native';

import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import {styles} from './styles';
import StockNotificationService from '../../services/StockNotificationService/StockNotificationService';

const AviseMeModal = ({ visible, sku, descricao, onPress }: { visible: boolean, sku: string, descricao: string, onPress: () => void }) => {

  const createNotification =  useCallback((sku: string, descricao: string)  => {
    StockNotificationService.createStockNotification(sku, descricao);
    onPress();
  }, []);


  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
    >
      <View style={styles.containerModal}>
        <View style={styles.containerFilter}>
          <Text
            style={{
              fontSize: 20,
              lineHeight: 26,
              color: 'black',
              textAlign: 'center',
              maxWidth: 300,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 20,
            }}
          >
            Tudo certo! Você será notificado assim que o produto estiver disponível em estoque novamente.
          </Text>

          <View style={styles.containerButton}>
            <ButtonComponent
              title="Confirmar"
              outlined
              width="80%"
              onPress={() => createNotification(sku, descricao)}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default AviseMeModal;
